import { useDispatch, useSelector } from "react-redux";
import { createSubscription, setFields, updateSubscription } from "../../features/subscriptionSlice";
import { useEffect, useState } from "react";
import { Field, Formik, Form } from "formik";
import { errorToastify, successToastify } from "../../utils/toastify.util";
import { subscriptionPlanSchema } from "../../utils/validation.util";
import { InputError, LevelReq } from "../../components/form/FormBody";

const SubscriptionModal = ({ closeModal }) => {
    const dispatch = useDispatch();
    const { isBtnLoad, isRedirect, fields } = useSelector((state) => state.subscription);
    const isEditMode = fields.id !== "";
    const [maxHunts, setMaxHunts] = useState(isEditMode && fields['max_hunts'] === null);
    const [maxChallenges, setMaxChallenges] = useState(isEditMode && fields['max_challenges'] === null);
    const [maxHuntItems, setMaxHuntItems] = useState(isEditMode && fields['max_hunt_items'] === null);
    const [maxChallengeItems, setMaxChallengeItems] = useState(isEditMode && fields['max_challenge_items'] === null);
    const [maxCreatedItems, setMaxCreatedItems] = useState(isEditMode && fields['max_created_items'] === null);
    const [maxPurchasedItems, setMaxPurchasedItems] = useState(isEditMode && fields['max_purchased_items'] === null);
    const [maxSavedHunt, setMaxSavedHunt] = useState(isEditMode && fields['max_saved_hunt'] === null);
    const [maxHuntTeams, setMaxHuntTeams] = useState(isEditMode && fields['max_hunt_teams'] === null);

    useEffect(() => {
        if (fields) {
            const shouldUseUnlimited = fields.id !== "";
            setMaxHunts(shouldUseUnlimited && fields['max_hunts'] === null);
            setMaxChallenges(shouldUseUnlimited && fields['max_challenges'] === null);
            setMaxHuntItems(shouldUseUnlimited && fields['max_hunt_items'] === null);
            setMaxChallengeItems(shouldUseUnlimited && fields['max_challenge_items'] === null);
            setMaxCreatedItems(shouldUseUnlimited && fields['max_created_items'] === null);
            setMaxPurchasedItems(shouldUseUnlimited && fields['max_purchased_items'] === null);
            setMaxSavedHunt(shouldUseUnlimited && fields['max_saved_hunt'] === null);
            setMaxHuntTeams(shouldUseUnlimited && fields['max_hunt_teams'] === null);
        }
    }, [fields]);

    const handleSubmit = (formData) => {
        const trialPeriodValue =
            formData.trial_period === null || formData.trial_period === ""
                ? 0
                : formData.trial_period;

        const payload = {
            ...formData,
            name: String(formData.name || "").trim(),
            description: String(formData.description || "").trim(),
            trialperiod: trialPeriodValue,
        };
        delete payload.trial_period;

        const selectedPlanType = formData.plan_type === "yearly" ? "yearly" : "monthly";

        if (!maxHunts && (formData.max_hunts === null || formData.max_hunts === "")) {
            errorToastify("Please fill in Max Number of credits.");
            return;
        }

        if (!maxChallenges && (formData.max_challenges === null || formData.max_challenges === "")) {
            errorToastify("Please fill in Max Number of saved Quest.");
            return;
        }

        if (!maxHuntItems && (formData.max_hunt_items === null || formData.max_hunt_items === "")) {
            errorToastify("Please fill in Max Number Hunt Challenges per Hunt.");
            return;
        }

        if (!maxChallengeItems && (formData.max_challenge_items === null || formData.max_challenge_items === "")) {
            errorToastify("Please fill in Max Number Hunt Challenges per Quest.");
            return;
        }

        if (!maxCreatedItems && (formData.max_created_items === null || formData.max_created_items === "")) {
            errorToastify("Please fill in Max number of saved created Challenges.");
            return;
        }

        if (!maxPurchasedItems && (formData.max_purchased_items === null || formData.max_purchased_items === "")) {
            errorToastify("Please fill in Max number of purchased challenges.");
            return;
        }

        if (!maxSavedHunt && (formData.max_saved_hunt === null || formData.max_saved_hunt === "")) {
            errorToastify("Please fill in Max save hunt.");
            return;
        }

        if (!maxHuntTeams && (formData.max_hunt_teams === null || formData.max_hunt_teams === "")) {
            errorToastify("Please fill in Max Number of Hunt Teams.");
            return;
        }

        if (formData.video_available === "" || formData.video_available === null || formData.video_available === 0) {
            errorToastify("Please fill in How long video available to download.");
            return;
        }

        if (payload.id === "") {
            dispatch(createSubscription(payload));
        } else {
            if (selectedPlanType === "monthly") {
                payload.price_annually = null;
            } else {
                payload.price_monthly = null;
            }
            dispatch(updateSubscription(payload));
        }
    };

    useEffect(() => {
        return () => {
	            dispatch(setFields({
	                name: "",
	                description: "",
                    plan_type: "monthly",
	                price_monthly: null,
	                price_annually: null,
	                trial_period: 0,
	                id: "",
	                is_ads: 0,
                    max_saved_hunt: 0,
	                max_hunts: null,
	                max_challenges: null,
                max_hunt_items: null,
                max_challenge_items: null,
                max_created_items: null,
                max_purchased_items: null,
                max_hunt_teams: null,
                is_relaunch: 0,
                is_relaunch_quests: 0,
	                max_share: 0,
	                video_available: 1
	            }));
	        }
	    }, [dispatch]);

    useEffect(() => {
        if (isRedirect) {
            if (fields.id !== "") {
                successToastify("Subscription Plan updated successfully.");
            } else {
                successToastify("Subscription Plan created successfully.");
            }
            closeModal();
        }
    }, [isRedirect, closeModal, fields.id]);

    return (
        <div className="container">
            <Formik
                initialValues={fields}
                enableReinitialize
                validationSchema={subscriptionPlanSchema}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue }) => {
                    const selectedPlanType = values.plan_type === "yearly" ? "yearly" : "monthly";
                    const priceFieldName =
                        selectedPlanType === "monthly" ? "price_monthly" : "price_annually";

                    const handleNumberChange = (e) => {
                        const { name, value, type } = e.target;
                        if (name === "price_monthly" || name === "price_annually") {
                            if (/^\d*\.?\d*$/.test(value)) {
                                setFieldValue(name, value);
                            }
                            return;
                        }
                        const newValue =
                            type === "number" ? (value === "" ? null : Number(value)) : value;
                        setFieldValue(name, newValue);
                    };

                    return (
                        <Form>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <LevelReq htmlFor="name" className="form-label">
                                            Name
                                        </LevelReq>
                                        <Field type="text" name="name" id="name" className="form-control" />
                                        <InputError name="name" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <LevelReq htmlFor="description" className="form-label">
                                            Description
                                        </LevelReq>
                                        <Field
                                            as="textarea"
                                            name="description"
                                            id="description"
                                            className="form-control"
                                            style={{ resize: "none", height: "100px" }}
                                        />
                                        <InputError name="description" />
                                    </div>
                                </div>

                                <div className="col-md-2">
                                    <div className="mb-3">
                                        <label className="form-label">Plan Type</label>
                                        <Field as="select" name="plan_type" className="form-select">
                                            <option value="monthly">Monthly</option>
                                            <option value="yearly">Yearly</option>
                                        </Field>
                                        <InputError name="plan_type" />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-3">
                                        <LevelReq htmlFor={priceFieldName} className="form-label">
                                            {selectedPlanType === "monthly" ? "Price Monthly" : "Price Annually"}
                                        </LevelReq>
                                        <Field
                                            type="text"
                                            name={priceFieldName}
                                            id={priceFieldName}
                                            className="form-control"
                                            value={
                                                selectedPlanType === "monthly"
                                                    ? (values.price_monthly ?? "")
                                                    : (values.price_annually ?? "")
                                            }
                                            onChange={handleNumberChange}
                                            readOnly={values.id === 1}
                                        />
                                        <InputError name={priceFieldName} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-3">
                                        <label className="form-label">Trial Period</label>
                                        <Field
                                            type="number"
                                            min="0"
                                            step="1"
                                            placeholder="in days"
                                            name="trial_period"
                                            className="form-control"
                                            value={values.trial_period ?? ""}
                                            onChange={handleNumberChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-3">
                                        <label className="form-label">Ads</label><br />
                                        <div className="form-check form-check-inline">
                                            <Field
                                                type="radio"
                                                name="is_ads"
                                                value={1}
                                                checked={values.is_ads === 1}
                                                onChange={() => setFieldValue("is_ads", 1)}
                                                className="form-check-input"
                                            /> Yes
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <Field
                                                type="radio"
                                                name="is_ads"
                                                value={0}
                                                checked={values.is_ads === 0}
                                                onChange={() => setFieldValue("is_ads", 0)}
                                                className="form-check-input"
                                            /> No
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-3">
                                        <label className="form-label">Relaunch Hunts</label><br />
                                        <div className="form-check form-check-inline">
                                            <Field
                                                type="radio"
                                                name="is_relaunch"
                                                value={1}
                                                checked={values.is_relaunch === 1}
                                                onChange={() => setFieldValue("is_relaunch", 1)}
                                                className="form-check-input"
                                            /> Yes
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <Field
                                                type="radio"
                                                name="is_relaunch"
                                                value={0}
                                                checked={values.is_relaunch === 0}
                                                onChange={() => setFieldValue("is_relaunch", 0)}
                                                className="form-check-input"
                                            /> No
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-3">
                                        <label className="form-label">Relaunch Quests</label><br />
                                        <div className="form-check form-check-inline">
                                            <Field
                                                type="radio"
                                                name="is_relaunch_quests"
                                                value={1}
                                                checked={values.is_relaunch_quests === 1}
                                                onChange={() => setFieldValue("is_relaunch_quests", 1)}
                                                className="form-check-input"
                                            /> Yes
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <Field
                                                type="radio"
                                                name="is_relaunch_quests"
                                                value={0}
                                                checked={values.is_relaunch_quests === 0}
                                                onChange={() => setFieldValue("is_relaunch_quests", 0)}
                                                className="form-check-input"
                                            /> No
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Number of Hosting Credits</label>
                                        <div className="d-flex align-items-center gap-3">
                                            <Field
                                                type="number"
                                                name="max_hunts"
                                                className="form-control"
                                                value={maxHunts ? "" : (values.max_hunts ?? "")}
                                                onChange={handleNumberChange}
                                                step="1"
                                                disabled={maxHunts}
                                            />
                                            <div className="form-check flex-shrink-0 m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="maxHunts"
                                                    checked={maxHunts}
                                                    onChange={(e) => {
                                                        setMaxHunts(e.target.checked);
                                                        if (e.target.checked) {
                                                            setFieldValue("max_hunts", "");
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label text-nowrap" htmlFor="maxHunts">
                                                    No Limit
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Max Number of Challenges per Hunt</label>
                                        <div className="d-flex align-items-center gap-3">
                                            <Field
                                                type="number"
                                                name="max_hunt_items"
                                                className="form-control"
                                                value={maxHuntItems ? "" : (values.max_hunt_items ?? "")}
                                                onChange={handleNumberChange}
                                                step="1"
                                                disabled={maxHuntItems}
                                            />
                                            <div className="form-check flex-shrink-0 m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="maxHuntItems"
                                                    checked={maxHuntItems}
                                                    onChange={(e) => {
                                                        setMaxHuntItems(e.target.checked);
                                                        if (e.target.checked) {
                                                            setFieldValue("max_hunt_items", "");
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label text-nowrap" htmlFor="maxHuntItems">
                                                    No Limit
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Max number of saved created Challenges</label>
                                        <div className="d-flex align-items-center gap-3">
                                            <Field
                                                type="number"
                                                name="max_created_items"
                                                className="form-control"
                                                value={maxCreatedItems ? "" : (values.max_created_items ?? "")}
                                                onChange={handleNumberChange}
                                                step="1"
                                                disabled={maxCreatedItems}
                                            />
                                            <div className="form-check flex-shrink-0 m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="maxCreatedItems"
                                                    checked={maxCreatedItems}
                                                    onChange={(e) => {
                                                        setMaxCreatedItems(e.target.checked);
                                                        if (e.target.checked) {
                                                            setFieldValue("max_created_items", "");
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label text-nowrap" htmlFor="maxCreatedItems">
                                                    No Limit
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Max Number of Hunt Teams</label>
                                        <div className="d-flex align-items-center gap-3">
                                            <Field
                                                type="number"
                                                name="max_hunt_teams"
                                                className="form-control"
                                                value={maxHuntTeams ? "" : (values.max_hunt_teams ?? "")}
                                                onChange={handleNumberChange}
                                                step="1"
                                                disabled={maxHuntTeams}
                                            />
                                            <div className="form-check flex-shrink-0 m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="maxHuntTeams"
                                                    checked={maxHuntTeams}
                                                    onChange={(e) => {
                                                        setMaxHuntTeams(e.target.checked);
                                                        if (e.target.checked) {
                                                            setFieldValue("max_hunt_teams", "");
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label text-nowrap" htmlFor="maxHuntTeams">
                                                    No Limit
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Max save hunt</label>
                                        <div className="d-flex align-items-center gap-3">
                                            <Field
                                                type="number"
                                                min="0"
                                                name="max_saved_hunt"
                                                className="form-control"
                                                value={maxSavedHunt ? "" : (values.max_saved_hunt ?? "")}
                                                onChange={handleNumberChange}
                                                step="1"
                                                disabled={maxSavedHunt}
                                            />
                                            <div className="form-check flex-shrink-0 m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="maxSavedHunt"
                                                    checked={maxSavedHunt}
                                                    onChange={(e) => {
                                                        setMaxSavedHunt(e.target.checked);
                                                        if (e.target.checked) {
                                                            setFieldValue("max_saved_hunt", "");
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label text-nowrap" htmlFor="maxSavedHunt">
                                                    No Limit
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Max Number of saved Quest</label>
                                        <div className="d-flex align-items-center gap-3">
                                            <Field
                                                type="number"
                                                name="max_challenges"
                                                className="form-control"
                                                value={maxChallenges ? "" : (values.max_challenges ?? "")}
                                                onChange={handleNumberChange}
                                                step="1"
                                                disabled={maxChallenges}
                                            />
                                            <div className="form-check flex-shrink-0 m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="maxChallenges"
                                                    checked={maxChallenges}
                                                    onChange={(e) => {
                                                        setMaxChallenges(e.target.checked);
                                                        if (e.target.checked) {
                                                            setFieldValue("max_challenges", "");
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label text-nowrap" htmlFor="maxChallenges">
                                                    No Limit
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Max Number of Challenges per Quest</label>
                                        <div className="d-flex align-items-center gap-3">
                                            <Field
                                                type="number"
                                                name="max_challenge_items"
                                                className="form-control"
                                                value={maxChallengeItems ? "" : (values.max_challenge_items ?? "")}
                                                onChange={handleNumberChange}
                                                step="1"
                                                disabled={maxChallengeItems}
                                            />
                                            <div className="form-check flex-shrink-0 m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="maxChallengeItems"
                                                    checked={maxChallengeItems}
                                                    onChange={(e) => {
                                                        setMaxChallengeItems(e.target.checked);
                                                        if (e.target.checked) {
                                                            setFieldValue("max_challenge_items", "");
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label text-nowrap" htmlFor="maxChallengeItems">
                                                    No Limit
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Max number of purchased challenges</label>
                                        <div className="d-flex align-items-center gap-3">
                                            <Field
                                                type="number"
                                                name="max_purchased_items"
                                                className="form-control"
                                                value={maxPurchasedItems ? "" : (values.max_purchased_items ?? "")}
                                                onChange={handleNumberChange}
                                                step="1"
                                                disabled={maxPurchasedItems}
                                            />
                                            <div className="form-check flex-shrink-0 m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="maxPurchasedItems"
                                                    checked={maxPurchasedItems}
                                                    onChange={(e) => {
                                                        setMaxPurchasedItems(e.target.checked);
                                                        if (e.target.checked) {
                                                            setFieldValue("max_purchased_items", "");
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label text-nowrap" htmlFor="maxPurchasedItems">
                                                    No Limit
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Days video saved for download</label>
                                                <Field
                                                    type="number"
                                                    placeholder="in days"
                                                    name="video_available"
                                                    className="form-control"
                                                    value={values.video_available ?? ""}
                                                    onChange={handleNumberChange}
                                                    step="1"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Max Share Limit of Quests</label>
                                                <Field
                                                    type="number"
                                                    placeholder="Max Share Limit"
                                                    name="max_share"
                                                    className="form-control"
                                                    value={values.max_share ?? ""}
                                                    onChange={handleNumberChange}
                                                    step="1"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Field type="hidden" name="id" />

                            <button type="submit" className="btn btn-primary me-3" disabled={isBtnLoad}>
                                Submit
                            </button>
                            <button type="button" className="btn btn-danger " disabled={isBtnLoad} onClick={closeModal}>
                                Cancel
                            </button>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default SubscriptionModal;
